import { getInfoByPath, TGetValueFn } from "@components/smart/FieldInfo";
import BindingContext, { createPath } from "@odata/BindingContext";
import { AddressEntity, PrIllnessLeaveEventEntity } from "@odata/GeneratedEntityTypes";
import { CountryCode } from "@odata/GeneratedEnums";

import { FormStorage } from "../../../../views/formView/FormStorage";

export const hasDoctorLocalPath = BindingContext.localContext("hasDoctor");
export const hasResidenceAddressLocalPath = BindingContext.localContext("hasResidenceAddress");
export const hasAdditionalFlagsLocalPath = BindingContext.localContext("hasAdditionalFlags");

// current address fields
export const CurrentStreetLocalPath = BindingContext.localContext("Street");
export const CurrentCityLocalPath = BindingContext.localContext("City");
export const CurrentPostalCodeLocalPath = BindingContext.localContext("PostalCode");
export const CurrentCountryLocalPath = BindingContext.localContext("Country");

export const CurrentLocalAddressFields = [
    CurrentStreetLocalPath,
    CurrentCityLocalPath,
    CurrentPostalCodeLocalPath,
    CurrentCountryLocalPath
];

export const isDoctorAddressFilled: TGetValueFn<boolean> = (args) => {
    const { storage } = args;
    const info = getInfoByPath(storage as FormStorage, PrIllnessLeaveEventEntity.DoctorName);
    const addressRows = info.collapsedRows;

    const hasValue = addressRows.find(row => row.find(field => {
        const value = storage.getValueByPath(field.id);
        if (field.id === createPath(PrIllnessLeaveEventEntity.DoctorAddress, AddressEntity.Country)) {
            return value && value?.Code !== CountryCode.CzechRepublic;
        }
        return !!value;
    }));
    return !!hasValue;
};

